<template>
  <v-container v-if='loaded' fill-height fluid grid-list-xl>

    <v-dialog v-model="openAuditTrail" max-width="1200px">
      <app-audit-trail-timeline entity="patch" v-if='openAuditTrail' :entity_id="patch.id" :fields='config.fields'/>
    </v-dialog>

    <v-flex>
      <app-upsert ref='upsert' :config="config" :item="patch" title="Patch"
        :readonly='patch.status === "CONFIRMED"'
        :subtitle="`${patch.protocol.name} - ${patch.status}`" hide-save>

        <template slot='headerActions'>
          <app-audit-trail-btn @click="openAuditTrail = true" />
          <!-- commentato per task 386 -->
          <!-- <app-patch v-if='patch.id && patch.status !== "INIT"' entity="patch" :entity_id="patch.id" :protocol_id="patch.protocol_id"/> -->

          <v-btn color="red" @click="$router.push('/movements')">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </template>

        <template v-slot:actions="{ item }">

          <!-- <v-btn v-if="patch.status === 'CONFIRMED'" class="mx-1"
            color="purple darken-2 white--text" :href='`${BASE_URL}/pdf/${patch.pdf}`'>
             DOCUMENTATION
            <v-icon right>mdi-file-pdf-box</v-icon>
          </v-btn> -->


          <v-btn
            v-if="patch.pdf && ['CONFIRMED'].includes(patch.status)"
            class="mx-1"
            color="purple darken-2 white--text"
            :href='`${BASE_URL}/pdf/${patch.pdf}`'>
            DOCUMENTATION
              <v-icon right light>mdi-file-pdf-box</v-icon>
          </v-btn>

          <v-btn v-if="patch.status === 'INIT'" class="mx-1 font-weight-light" color="primary" :loading="loading"
            :disabled="!nDrugs || loading" @click="confirm(item)">CONFIRM</v-btn>

          <v-btn color='error' :to="`/${patch.entity}/${patch.entity_id}`"><v-icon>mdi-bug</v-icon>View a issue</v-btn>

          <app-table title="Patch"
            :config="drugConfig" upsert-max-width="850px" @loaded="loadedDrugs"
            :hide-upsert="patch.status === 'CONFIRMED'" :hide-actions="patch.status === 'CONFIRMED'"
            :filters="{ patch_id }" no-search
            :hidden-fields="{ patch_id, protocol_id: patch.protocol_id }" />

        </template>

      </app-upsert>

    </v-flex>

  </v-container>
</template>

<script>
/* eslint-disable no-case-declarations */

import config from './config_patch.js'
import drugConfig from './drug_index.js'
const { getDetail } = require('@/api/base_entity')
const { confirmPatch } = require('@/api/patch')
// import serialHelpers from '../../helpers'
// const { updateBalance } = require('@/api/balance')
const BASE_URL = process.env.VUE_APP_BASE_API

// const { updateAvailableSerials } = require('@/api/response')
// const { updateSiteResponse } = require('@/api/siterequest')

export default {
  data() {
    return {
      config,
      drugConfig,
      BASE_URL,
      patch_id: null,
      nDrugs: 0,
      drugs: [],
      patch: {},
      loaded: false,
      loading: false,
      openAuditTrail: false
    }
  },
  async created() {
    this.patch_id = Number(this.$route.params.patch_id)
    this.patch = await getDetail('patch', { id: this.patch_id })
    this.loaded = true
  },
  async beforeRouteUpdate (to, from, next) {
    this.loaded = false
    this.patch_id = Number(to.params.patch_id)
    this.patch = await getDetail('patch', { id: this.patch_id })
    this.loaded = true
    next()
  },
  methods: {
    loadedDrugs(items) {
      this.drugs = items
      this.nDrugs = items.length
    },
    async confirm() {
      if (!this.$refs.upsert.validate()) return
      this.loading = true

      try {
        const formData = new FormData()
        formData.append('pdf', this.patch['pdf'])
        await confirmPatch(this.patch_id, formData)
        await this.$router.go()
      } catch (e) {
        this.$root.$emit('openSnackbar', {
          message: 'An Error occurred. ' +
            e && e.response ? e.response.data.message : 'Error',
          color: 'error'
        })
        this.loading = false
      }
    },
  }
}
</script>
